/*  React  */
import React, { ReactNode, createContext, useContext, useMemo } from 'react';

export interface FormFactoryContextType {
    applicationId: string;
    clientId: string;
}

export const FormFactoryContext = createContext<
    FormFactoryContextType | undefined
>(undefined);

/**
 * Provides the applicationId and clientId to the form factory.
 */
export const FormFactoryContextProvider = ({
    applicationId,
    clientId,
    children
}: FormFactoryContextType & { children: ReactNode }) => {
    const providerValues = useMemo(
        () => ({ applicationId, clientId }),
        [applicationId, clientId]
    );

    return (
        <FormFactoryContext.Provider value={providerValues}>
            {children}
        </FormFactoryContext.Provider>
    );
};

export const useFormFactoryContext = () => {
    const context = useContext(FormFactoryContext);

    if (context === undefined) {
        throw new Error(
            '`useFormFactoryContext` must be used within `FormFactoryContextProvider`'
        );
    }

    return context;
};
